export const COMMENT_APPLICABLE_METADATA_KEYS = ["Confidential Flag", "Tribal Flag", "PII Review", "Staff Restricted Access"];
export const COMMENT_APPENDER = " Comments";
export const PORTAL_USER_INFO_KEY = "Portal User Info";
export const MAX_CHARS = 250;